import React, { Component } from "react";
import PubSub from "pubsub-js";

class Timeline extends Component {
    _secondsToHms = (t) => {
        const d = Number(t);
        var h = Math.floor(d / 3600);
        var m = Math.floor((d % 3600) / 60);
        var s = Math.floor((d % 3600) % 60);
        return (
            (h > 0 ? h + ":" + (m < 10 ? "0" : "") : "") +
            m +
            ":" +
            (s < 10 ? "0" : "") +
            s
        );
    };

    _onClick = (e) => {
        const percent = (e.pageX * 100) / window.innerWidth;
        PubSub.publish("SEEK", { percent: percent });
    };

    render() {
        const { progress, duration, nextVideo } = this.props;
        const showNext = duration - progress.playedSeconds < 20;
        // console.log("showNext",nextVideo)
        return (
            <div className="timeline" onClick={this._onClick}>
                <div className="timecode">
                    {this._secondsToHms(progress.playedSeconds)}/
                    {this._secondsToHms(duration)}
                </div>
                <div
                    className="timeline--played"
                    style={{ width: progress.played * 100 + "%" }}
                ></div>
                <div
                    className="timeline--loaded"
                    style={{ width: progress.loaded * 100 + "%" }}
                ></div>
                {nextVideo && (
                    <div
                        className={"next-video " + (showNext ? "show" : "")}
                        onClick={() => PubSub.publish("NEXT")}
                    >
                        Coming next ☞☞☞ {nextVideo.title}
                    </div>
                )}
            </div>
        );
    }
}

export default Timeline;



// WEBPACK FOOTER //
// ./src/components/Timeline.jsx